import { companyDetails } from "../data/invoiceDefaults";
import { calculateTotal, formatMoney } from "./invoiceMath";

export const createQrCodeContent = (invoice) => {
  const lines = [
    companyDetails.name,
    `Invoice: ${invoice.info.invoiceNumber}`,
    `Issue date: ${invoice.info.issueDate}`,
    `Currency: ${invoice.info.currencyCode}`,
    `Amount: ${invoice.info.currencySymbol} ${formatMoney(calculateTotal(invoice.items))}`,
    `Client: ${invoice.client.name}`,
    invoice.client.phone ? `Client phone: ${invoice.client.phone}` : "",
    invoice.client.email ? `Client email: ${invoice.client.email}` : "",
    `Fortress email: ${companyDetails.email}`,
    `Fortress phone: ${companyDetails.telephone}`,
    `Website: ${companyDetails.website}`,
  ];

  return lines.filter(Boolean).join("\n");
};
